import type { Note } from '../types';

export type Hand = 'left' | 'right';

/**
 * Which hand a note belongs to. Resolves `note.assignedHand` (OTO-25 dynamic
 * DP reassignment) first, falling back to `note.staff` (1=treble/right,
 * 2=bass/left) when absent/null -- never from pitch. Cross-hand passages
 * (e.g. left hand playing above middle C) must keep the resolved hand, not
 * flip by register.
 */
export function getNoteHand(note: Note): Hand {
  const hand = note.assignedHand ?? note.staff;
  return hand === 2 ? 'left' : 'right';
}

/**
 * Numeric (1|2) resolved hand -- for consumers that need the staff-shaped
 * value (e.g. PianoKeyboard's expected-staff map) rather than the 'left'/
 * 'right' string `getNoteHand()` returns. Same resolution: assignedHand,
 * falling back to staff.
 */
export function getResolvedStaff(note: Note): 1 | 2 {
  return note.assignedHand ?? note.staff;
}
